import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../Services/translation';
import { update } from '../../Actions/Cart.action';
import RemoveIcon from '../../../icons/minus-oval.svg'


class CartSummaryRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    onDeleteRequest(rowSystemId) {
        this.props.removeOrderRow(rowSystemId);
    }

    render() {
        const cartRow = this.props.data;

        return (
            <Fragment>
                <>
                    {cartRow &&
                        <div className="cart-summary__row" key={cartRow.rowSystemId + cartRow.header}>
                            <span className="cart-summary__row-column cart-summary__row-column--header" >{cartRow.header}</span>
                            <span className="cart-summary__row-column cart-summary__row-column--value" >
                                {cartRow.value}
                            </span>
                            <span className="cart-summary__row-column cart-summary__row-column--price" >{cartRow.priceFormatted}

                                {cartRow.showRemoveButton &&
                                    <a className="cart-summary__row-column--remove-item cart--remove-item-button" onClick={event => (this.onDeleteRequest(cartRow.rowSystemId))} ><RemoveIcon className="icon icon__remove-item" /></a>
                                }
                            </span>
                            {cartRow.description && cartRow.fieldId === 'Model' &&
                                <Fragment>
                                    <span className="cart-summary__row-column cart-summary__row-column--car-data-fillleft"></span>
                                    <span className="cart-summary__row-column cart-summary__row-column--car-data">{cartRow.description}</span>
                                </Fragment>
                            }
                        </div>
                    }
                </>
            </Fragment >
        );
    }
}

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeOrderRow: (rowId) => dispatch(update(rowId, 0))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CartSummaryRow);